/* Native cart.js owns cart mutations; keep the shared header count in sync. */
(() => {
  const root = document.querySelector('.rf-cart-page');
  if (!root || typeof subscribe !== 'function') return;
  subscribe(PUB_SUB_EVENTS.cartUpdate, ({ cartData }) => {
    if (!cartData || !Number.isFinite(cartData.item_count)) return;
    root.querySelectorAll('.rf-cart-count').forEach(el => { el.textContent = `(${cartData.item_count})`; });
    root.querySelectorAll('a.rf-cart').forEach(el => { el.setAttribute('aria-label', (el.dataset.countLabel || 'Cart, items: __COUNT__').replace('__COUNT__', cartData.item_count)); });
  });
})();
